import { useLayoutEffect, useRef, useState, type CSSProperties } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

const RecentConversationTitle = ({ title }: { title: string }) => {
  const viewportRef = useRef<HTMLSpanElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);
  const [overflow, setOverflow] = useState(0);

  useLayoutEffect(() => {
    const measure = () => {
      const viewport = viewportRef.current;
      const text = textRef.current;
      if (!viewport || !text) return;
      setOverflow(Math.max(0, text.scrollWidth - viewport.clientWidth));
    };

    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [title]);

  const style = {
    "--recent-title-overflow": `${overflow}px`,
    "--recent-title-duration": `${Math.max(2.2, overflow / 48 + 1.5)}s`,
  } as CSSProperties;

  return (
    <span className={styles.recentItemViewport} ref={viewportRef}>
      <span
        ref={textRef}
        className={classNames(styles.recentItemText, {
          [styles.recentItemTextScrollable]: overflow > 1,
        })}
        style={style}
      >
        {title}
      </span>
    </span>
  );
};

export default RecentConversationTitle;
